export const userManagementQueryKeys = {
  all: ['userManagement'] as const,
  lists: () => [...userManagementQueryKeys.all, 'list'] as const,
  list: (filters?: Record<string, any>) =>
    [...userManagementQueryKeys.lists(), { filters }] as const,
}
